import styled from 'styled-components';
import DocsRejectModal from './DocsRejectModal';

export default styled(DocsRejectModal)`
  .docs-reject-modal {
    &__reject-field {
      margin-bottom: 2rem;
      width: 100%;
    }

    &__reject-actions {
      display: flex;
      justify-content: flex-end;
    }
  }
`;
